import Modal from "./modal";
import axios from "axios";

export default class addToCart {


    constructor() {
        if (document.getElementById('addedCartModal')) {
            this.modal = new Modal('addedCartModal');
            this.initAddToCart();
        }
    }

    initAddToCart() {
        const buttons = document.querySelectorAll('.cart-button');

        buttons.forEach(button => {
            this.initButton(button);
        });
    }

    initButton(button) {
        let modal = this.modal;
        button.addEventListener('click', e => {
            e.preventDefault();
            let quantity = 1;

            let variantID = button.dataset.variantId;
            let quantityInput = button.parentElement.querySelector('input[name=quantity]');
            if (quantityInput) {
                let inputValue = parseInt(quantityInput.value);
                if (inputValue !== 0) {
                    quantity = inputValue
                }
            }

            let icon = button.querySelector('i');
            icon.classList.remove('icon-shopping-basket');
            icon.classList.add('loader');

            axios({
                method: 'post',
                url: '/winkelmandje/toevoegen',
                data: {
                    variant_id: variantID,
                    quantity: quantity
                }
            })
                .then(response => { // success
                    const modalElement = this.modal.modal;
                    let productImage = modalElement.querySelector('.product-image');
                    let brandName = modalElement.querySelector('.brand-name');
                    let productName = modalElement.querySelector('.product-name');
                    let price = modalElement.querySelector('.price');
                    let priceFrom = modalElement.querySelector('.price-from');
                    let crossSellContainer = modalElement.querySelector('.cross-sell-container');
                    let cartInfo = document.querySelector('header .cart > div');
                    const data = response.data;

                    productImage.setAttribute('src', data.image);
                    productImage.setAttribute('alt', data.brand_name ? data.brand_name + ' ' + data.product_name : data.product_name);
                    brandName.innerText = data.brand_name;
                    productName.innerText = data.product_name;

                    if (data.price_sale) {
                        priceFrom.classList.remove('d-none');
                        priceFrom.querySelector('s').innerText = data.price;
                        price.innerText = data.price_sale;
                    } else {
                        priceFrom.classList.add('d-none');
                        price.innerText = data.price;
                    }

                    const crossSellProducts = data.cross_sell_products;
                    if (crossSellProducts.length > 0) {
                        crossSellContainer.classList.remove('d-none');
                        let row = crossSellContainer.querySelector('.row');
                        row.innerHTML = '';
                        crossSellProducts.forEach(crossSellProduct => {
                            let div = document.createElement('div');
                            div.classList.add('col-12', 'col-sm-6', 'col-lg-3');
                            div.innerHTML = crossSellProduct;

                            let crossSellButton = div.querySelector('.cart-button');
                            if (crossSellButton) {
                                this.initButton(crossSellButton);
                            }

                            row.append(div);
                        });
                    } else {
                        crossSellContainer.classList.add('d-none');
                    }

                    cartInfo.classList.add('show');
                    cartInfo.innerText = data.cart_sum;

                    modal.open();
                })
                .catch(function (error) { // error
                    console.log(error);
                })
                .then(function () { // always
                    icon.classList.add('icon-shopping-basket');
                    icon.classList.remove('loader');
                });
        });
    }
}
